const handleCharLimit = (word: string, limit: number): string => {
  if (word?.length < limit) {
    return word;
  }
  return `${word?.substring(0, 24)}...`;
};

export default handleCharLimit;
